<template>
  <BTableCommon
    v-model="selected"
    type="users-actions"
    :list="list"
    :pagination="pagination"
    :ordering="filters.ordering"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"
    @change:pagination="onChangePagination"
    @change:sort="onChangeSort"
  />
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { UsersActionsModel as Model } from './Model'
import {
  usersActionsStoreModule as StoreModule,
} from './store'

import BTableCommon from '@/components/tables/BTableCommon.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewUsersActionsList',
  components: {
    BTableCommon,
  },
  mixins: [
    listMixin,
  ],
  props: {
    user_id: {
      type: [Number, String],
      required: true,
    },
  },
  data: (vm) => ({
    defaultParams: {
      user_id: vm.user_id,
    },
  }),
}
</script>
